exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup[data-v-72049d3f]{position:relative;display:inline-block;padding:7px 10px;background:#ff5714;color:#fff;font-size:.9230769231rem}.popup[data-v-72049d3f]::before{position:absolute;top:100%;left:50%;border:6px solid transparent;border-top:6px solid #ff5714;content:\"\";transform:translateX(-50%)}", ""]);

// exports
